import { render } from "./App.vue?vue&type=template&id=2ba1cb7f&scoped=true&bindings={}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2ba1cb7f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2ba1cb7f"

export default script